const initialState = {
  lottery_data: [],
  lottery_round: [],
  lottery_type: [],
  category_lottery: [],
  lottery_round_risk_check: null
}

const lottery = (state = initialState, action) => {
  switch (action.type) {
    case 'LOTTERY_GET_DATA':
      return {
        ...state,
        lottery_data: action.data
      }
    case 'LOTTERY_ROUND_GET_DATA':
      return {
        ...state,
        lottery_round: action.data
      }
    case 'LOTTERY_TYPE_GET_DATA':
      return {
        ...state,
        lottery_type: action.data
      }
    case 'CATEGORY_LOTTERY_GET_DATA':
      return {
        ...state,
        category_lottery: action.data
      }
       case 'LOTTERY_GET_ROUND_RISK_CHECK':
      return {
        ...state,
        lottery_round_risk_check: action.data
      }
    default:
      return { ...state }
  }
}

export default lottery